import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('rect', { x: '20.76', y: '11.58', width: '2.83', height: '1.3' }),
  React.createElement('rect', { x: '20.64', y: '14.9', width: '2.83', height: '1.3' }),
  React.createElement('rect', { x: '20.65', y: '18.23', width: '2.83', height: '1.3' }),
  React.createElement('rect', { x: '20.65', y: '21.55', width: '2.83', height: '1.3' }),
  React.createElement('rect', { x: '20.65', y: '24.88', width: '2.83', height: '1.3' }),
  React.createElement('path', { d: 'M23.36,9H8.64a2.78,2.78,0,0,0-2.89,2.65V26.12a2.78,2.78,0,0,0,2.89,2.65H23.36a2.78,2.78,0,0,0,2.89-2.65V11.64A2.78,2.78,0,0,0,23.36,9ZM25,26.12a1.49,1.49,0,0,1-1.59,1.35H8.64a1.49,1.49,0,0,1-1.59-1.35V11.64a1.49,1.49,0,0,1,1.59-1.35H23.36A1.49,1.49,0,0,1,25,11.64Z' }),
  React.createElement('path', { d: 'M7.35,7.7h17.3a.65.65,0,0,0,0-1.3h-8V4.53h2.12a.65.65,0,1,0,0-1.3H13.23a.65.65,0,0,0,0,1.3h2.12V6.4h-8a.65.65,0,0,0,0,1.3Z' })
));